(function ($) {
  /* Product Compare Page 2024/9/19 Adrian Carlos */

  var gHasChecked = false;
  var compareProducts = [];

  function update_compare_section() {    
    for (let i = 0; i < compareProducts.length; i++) {
      let boxHtml = `
        <img src="${compareProducts[i].product_image}" class="compare-box-image"/>
        <div class="compare-box-title">${compareProducts[i].product_title}</div>
        <button class="compare-box-remove" data-product-id="${compareProducts[i].product_id}">
          <svg class="icon-remove product-compare-drawer__remove-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">      <path fill="currentColor" d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>    </svg>
        </button>
      `;
      $(`.compare-box-${i}`).addClass('added-product');
      $(`.compare-box-${i}`).html(boxHtml);
    }
    for (let i = 0; i < 3 - compareProducts.length; i++) {
      let boxHtml = '';
      if (i == 2)
        boxHtml = `Select first item to compare`;
      if (i == 1)
        boxHtml = `Select second item to compare`;
      if (i == 0)
        boxHtml = `Select third item to compare`;
      $(`.compare-box-${2 - i}`).removeClass('added-product');
      $(`.compare-box-${2 - i}`).html(boxHtml);
    }

    let $checkboxes = $('.product-collection .grid-item .productitem__compare-checkbox');
    let hasChecked = false;
    let checkedCount = 0;
    $checkboxes.each(function() {
      if ($(this).is(':checked')) {
        hasChecked = true;
        checkedCount++;
      }
    });
    gHasChecked = hasChecked;
    if (checkedCount > 0) {
      $('.compare-action-do').html(`Compare(${checkedCount})`);
    } else {
      $('.compare-action-do').html('Compare');
    }

    if (gHasChecked) {
      $('.product-collection .grid-item .productitem__compare-wrapper').attr('data-animation-state', 'open');
      if (checkedCount >= 3) {        
        $checkboxes.each(function() {
          if (!$(this).is(':checked')) {
            $(this).prop('disabled', true);
          }
        });
      } else {
        $checkboxes.each(function() {
          if (!$(this).is(':checked')) {
            $(this).prop('disabled', false);
          }
        });
      }
      if (!$('.collection-compare-section').hasClass('show-box')) {
        $('.collection-compare-section').addClass('show-box');
      }
      $('.collection-compare-section.show-box .compare-action-do').removeClass('disabled');
    } else {
      $('.product-collection .grid-item .productitem__compare-wrapper:not(.mobile)').attr('data-animation-state', 'closed');
      if ($('.collection-compare-section').hasClass('show-box')) {
        $('.collection-compare-section').removeClass('show-box');
      }
      $('.collection-compare-section.show-box .compare-action-do').addClass('disabled');
    }
  }

  $(document).on('mouseover', '.product-collection .grid-item', function() {
    $(this).find('.productitem__compare-wrapper').attr('data-animation-state', 'open');
  });
  
  $(document).on('mouseleave', '.product-collection .grid-item', function() {
    if (!gHasChecked) {
      $(this).find('.productitem__compare-wrapper').attr('data-animation-state', 'closed');
    }
  });

  $(document).on('change', '.product-collection .grid-item .productitem__compare-checkbox', function() {
    let product_id = $(this).attr('data-product-id');
    let product_title = $(this).attr('data-product-title');
    let product_image = $(this).attr('data-product-image'); 
    let product_handle = $(this).attr('data-product-handle'); 
    let found = false;
    let found_index = -1;
    for (let i = 0; i < compareProducts.length; i++) {
      if (compareProducts[i].product_id == product_id) {
        found = true;
        found_index = i;
      }
    }
    if ($(this).is(':checked')) {
      compareProducts.push({
        product_id: product_id,
        product_title: product_title,
        product_image: product_image,
        product_handle: product_handle,
      });
    } else {
      compareProducts.splice(found_index, 1);
    }

    update_compare_section();
  });

  $(document).on('click', '.collection-compare-section.show-box .collection-compare-box .compare-box-remove', function() {
    let found = false;
    let found_index = -1;
    let product_id = $(this).attr('data-product-id');
    for (let i = 0; i < compareProducts.length; i++) {
      if (compareProducts[i].product_id == product_id) {
        found = true;
        found_index = i;
      }
    }
    compareProducts.splice(found_index, 1);

    $(`.productitem__compare input.productitem__compare-checkbox[data-product-id="${product_id}"]`).prop('checked', false);
    update_compare_section();
  });

  $(document).on('click', '.collection-compare-section.show-box .compare-action-clear', function() {
    compareProducts.splice(0, compareProducts.length);
    $(`.productitem__compare input.productitem__compare-checkbox`).prop('checked', false);
    update_compare_section();
  });

  $(document).on('click', '.collection-compare-section.show-box .compare-action-do', function() {
    if (compareProducts.length == 0)
      return;
    
    let product_handles = [];
    for (let i = 0; i < compareProducts.length; i++) {
      product_handles.push(compareProducts[i].product_handle);
    }
    location.href="/pages/product-compare?products=" + product_handles.join(',');
  });

  $(document).on('change', '.product-compare-filter .compare-filter-option', function() {
    let data_option = $(this).attr('data-filter-option');
    let filter_availability = $('#compare-filter-availability').is(':checked');
    let filter_oxygen_flow = $('#compare-filter-oxygen_flow').is(':checked');
    let filter_oxygen_concentration = $('#compare-filter-oxygen_concentration').is(':checked');
    let filter_noise_level = $('#compare-filter-noise_level').is(':checked');
    let filter_battery_duration = $('#compare-filter-battery_duration').is(':checked');
    let filter_power_settings = $('#compare-filter-power_settings').is(':checked');
    let filter_weight = $('#compare-filter-weight').is(':checked');
    
    $(`.compare-filter-option[data-filter-option="${data_option}"]`).prop('checked', $(`#compare-filter-${data_option}`).is(':checked'));
    
    if (!filter_availability && !filter_oxygen_flow && !filter_oxygen_concentration &&
       !filter_noise_level && !filter_battery_duration && !filter_power_settings &&
       !filter_weight) {
      $(`.product-compare-list-box .product-compare-availability`).removeClass('hidden-box');
      $(`.product-compare-list-box .product-specifications`).removeClass('hidden-box');
      $(`.product-compare-list-box .product-compare-specifications-title`).removeClass('hidden-box');
      $(`.product-specifications.divider`).removeClass('hidden-box');
      return;
    }

    if (!filter_oxygen_flow && !filter_oxygen_concentration &&
       !filter_noise_level && !filter_battery_duration && !filter_power_settings &&
       !filter_weight) {
      $(`.product-compare-list-box .product-compare-specifications-title`).addClass('hidden-box');
      $(`.product-specifications`).addClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-compare-specifications-title`).removeClass('hidden-box');
      $(`.product-specifications.divider`).removeClass('hidden-box');
    }
    
    if (filter_availability) {
      $(`.product-compare-list-box .product-compare-availability`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-compare-availability`).addClass('hidden-box');
    }
    if (filter_oxygen_flow) {
      $(`.product-compare-list-box .product-specifications.product-compare-oxygen_flow`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-oxygen_flow`).addClass('hidden-box');
    }
    if (filter_oxygen_concentration) {
      $(`.product-compare-list-box .product-specifications.product-compare-oxygen_concentration`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-oxygen_concentration`).addClass('hidden-box');
    }
    if (filter_noise_level) {
      $(`.product-compare-list-box .product-specifications.product-compare-noise_level`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-noise_level`).addClass('hidden-box');
    }
    if (filter_battery_duration) {
      $(`.product-compare-list-box .product-specifications.product-compare-battery_duration`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-battery_duration`).addClass('hidden-box');
    }    
    if (filter_power_settings) {
      $(`.product-compare-list-box .product-specifications.product-compare-power_settings`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-power_settings`).addClass('hidden-box');
    }    
    if (filter_weight) {
      $(`.product-compare-list-box .product-specifications.product-compare-weight`).removeClass('hidden-box');
    } else {
      $(`.product-compare-list-box .product-specifications.product-compare-weight`).addClass('hidden-box');
    }
    
  });

  $(document).on('click', '.product-preview-flex button.compare-box-remove', function() {
    let product_id = $(this).attr('data-product-id');
    $(`.product-preview-box[data-product-id="${product_id}"]`).remove();

    let product_not_000 = $('.product-compare-section.body .product-preview-box').not('[data-product-id="000"]');
    if (product_not_000.length == 1) {
      let boxBodyHtml = `
        <div class="product-preview-box" data-product-id="000">
          <div class="product-preview" style="display: flex; align-items: center; justify-content: center;">
            <div class="product-preview-flex">Select another item to compare</div>
            <div></div>
          </div>
          <div class="product-compare-availability"></div>
          <div class="product-compare-specifications-title"></div>
          <div class="product-specifications product-compare-oxygen_flow"></div>
          <div class="product-specifications product-compare-oxygen_concentration"></div>
          <div class="product-specifications product-compare-noise_level"></div>
          <div class="product-specifications product-compare-battery_duration"></div>
          <div class="product-specifications product-compare-power_settings"></div>
          <div class="product-specifications product-compare-weight"></div>
          <div class="product-specifications divider"></div>
        </div>
      `;
      let origBodyHtml = $('.product-compare-section.body .product-compare-list-box').html();
      $('.product-compare-section.body .product-compare-list-box').html(origBodyHtml + boxBodyHtml);

      let boxStickyHtml = `
        <div class="product-preview-box" data-product-id="000">
          <div class="product-preview" style="display: flex; align-items: center; justify-content: center;">
            <div class="product-preview-flex">Select another item to compare</div>
            <div></div>
          </div>
        </div>
      `;
      let origStickyHtml = $('.product-compare-section.sticky-bar .product-compare-list-box').html();
      $('.product-compare-section.sticky-bar .product-compare-list-box').html(origStickyHtml + boxStickyHtml);
    }

    if (product_not_000.length == 0) {
      $(`.product-preview-box[data-product-id="000"]`).remove();
      $(`.product-compare-section.sticky-bar`).remove();
      let boxHtml = `
        <div class="product-compare-empty">
          <div style="align-self: center;">
            <p>No products selected</p>
            <a class="product-compare__continue-shopping" href="/collections/products">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">    <g id="cart" clip-path="url(#clip0_743_3666)">    <path id="Vector" d="M7.62626 4.4993C8.09857 2.21723 10.12 0.501953 12.542 0.501953H12.9462C15.3683 0.501953 17.3897 2.21723 17.862 4.4993H20.5567C22.8618 4.4993 24.6899 6.44249 24.5493 8.74329L23.9881 17.9263C23.7624 21.6196 20.7013 24.4993 17.0011 24.4993H8.4902C4.79002 24.4993 1.72893 21.6196 1.50323 17.9263L0.942049 8.74329C0.801443 6.44249 2.62951 4.4993 4.9346 4.4993H7.62626ZM9.17288 4.4993H16.3154C15.8772 3.05401 14.5346 2.00196 12.9462 2.00196H12.542C10.9536 2.00196 9.611 3.05401 9.17288 4.4993ZM17.0011 22.4993C19.6441 22.4993 21.8306 20.4424 21.9918 17.8043L22.553 8.62129C22.6233 7.47089 21.7093 6.4993 20.5567 6.4993H4.9346C3.78206 6.4993 2.86802 7.47089 2.93833 8.62129L3.49951 17.8043C3.66073 20.4424 5.84722 22.4993 8.4902 22.4993H17.0011ZM17.2162 8.99006C16.802 8.99006 16.4662 9.32585 16.4662 9.74006V10.5407C16.4662 12.5963 14.7997 14.2628 12.7441 14.2628C10.6884 14.2628 9.02199 12.5963 9.02199 10.5407V9.74006C9.02199 9.32585 8.68621 8.99006 8.27199 8.99006C7.85778 8.99006 7.52199 9.32585 7.52199 9.74006V10.5407C7.52199 13.4247 9.86001 15.7628 12.7441 15.7628C15.6282 15.7628 17.9662 13.4247 17.9662 10.5407V9.74006C17.9662 9.32585 17.6304 8.99006 17.2162 8.99006Z" fill="#2484C4"></path>    </g>    <defs>    <clipPath id="clip0_743_3666">    <rect width="24" height="24" fill="white" transform="translate(0.745728 0.5)"></rect>    </clipPath>    </defs>    </svg>                                                                                                            
              Continue shopping
            </a>
          </div>
        </div>
      `;
      $(`.product-compare-section.body .product-compare-list-box`).html(boxHtml);
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
  });

  $(document).on('click', '.product-compare-remove-all', function() {
    let boxHtml = `
      <div class="product-compare-empty">
        <div style="align-self: center;">
          <p>No products selected</p>
          <a class="product-compare__continue-shopping" href="/collections/oxygen-concentrator">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">    <g id="cart" clip-path="url(#clip0_743_3666)">    <path id="Vector" d="M7.62626 4.4993C8.09857 2.21723 10.12 0.501953 12.542 0.501953H12.9462C15.3683 0.501953 17.3897 2.21723 17.862 4.4993H20.5567C22.8618 4.4993 24.6899 6.44249 24.5493 8.74329L23.9881 17.9263C23.7624 21.6196 20.7013 24.4993 17.0011 24.4993H8.4902C4.79002 24.4993 1.72893 21.6196 1.50323 17.9263L0.942049 8.74329C0.801443 6.44249 2.62951 4.4993 4.9346 4.4993H7.62626ZM9.17288 4.4993H16.3154C15.8772 3.05401 14.5346 2.00196 12.9462 2.00196H12.542C10.9536 2.00196 9.611 3.05401 9.17288 4.4993ZM17.0011 22.4993C19.6441 22.4993 21.8306 20.4424 21.9918 17.8043L22.553 8.62129C22.6233 7.47089 21.7093 6.4993 20.5567 6.4993H4.9346C3.78206 6.4993 2.86802 7.47089 2.93833 8.62129L3.49951 17.8043C3.66073 20.4424 5.84722 22.4993 8.4902 22.4993H17.0011ZM17.2162 8.99006C16.802 8.99006 16.4662 9.32585 16.4662 9.74006V10.5407C16.4662 12.5963 14.7997 14.2628 12.7441 14.2628C10.6884 14.2628 9.02199 12.5963 9.02199 10.5407V9.74006C9.02199 9.32585 8.68621 8.99006 8.27199 8.99006C7.85778 8.99006 7.52199 9.32585 7.52199 9.74006V10.5407C7.52199 13.4247 9.86001 15.7628 12.7441 15.7628C15.6282 15.7628 17.9662 13.4247 17.9662 10.5407V9.74006C17.9662 9.32585 17.6304 8.99006 17.2162 8.99006Z" fill="#2484C4"></path>    </g>    <defs>    <clipPath id="clip0_743_3666">    <rect width="24" height="24" fill="white" transform="translate(0.745728 0.5)"></rect>    </clipPath>    </defs>    </svg>                                                                                                            
            Continue shopping
          </a>
        </div>
      </div>
    `;
    $(`.product-compare-section.body .product-compare-list-box`).html(boxHtml);
    $(`.product-compare-section.sticky-bar`).remove();
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });

  $(document).on('click', '.filter-modal-action', function() {
    $(`.product-compare-filter-panel`).css('display', 'block');
  });

  $(document).on('click', '.filter-modal-close', function() {
    $(`.product-compare-filter-panel`).css('display', 'none');
  });

  var current_url = window.location.href;
  console.log(current_url);
  $(window).on('scroll', function() {
    if (current_url.includes('pages/product-compare')) {
      let scrollTop = $(window).scrollTop();
      let stickyBar = $(`#shopify-section-product-compare-sticky`);
      let previewTop = 0;
      if ($(`.product-compare-section.body .product-compare-list-box .product-preview-box .product-preview`)) {
        $(`.product-compare-section.body .product-compare-list-box .product-preview-box .product-preview`).offset().top;
      }
      let previewHeight = 0;
      if ($(`.product-compare-section.body .product-compare-list-box .product-preview-box .product-preview`)) {
        $(`.product-compare-section.body .product-compare-list-box .product-preview-box .product-preview`).outerHeight();
      }
      let stickyHeaderHeight = 0;
      if ($(`#sticky-wrapper`).hasClass('is-sticky')) {
        stickyHeaderHeight = $(`#sticky-wrapper`).outerHeight();
      } else {
        stickyBar.removeClass('open');
        return;
      }
      if (scrollTop > previewTop + previewHeight) {
        stickyBar.css('top', stickyHeaderHeight);
        stickyBar.addClass('open');
        let bodyScrollLeft = $(`.product-compare-section.body .product-compare-list-box`).scrollLeft();
        $(`.product-compare-section.sticky-bar .product-compare-list-box`).scrollLeft(bodyScrollLeft);
      } else {
        stickyBar.removeClass('open');
      }
    }
  });

  $(`.product-compare-section.sticky-bar .product-compare-list-box`).on('scroll', function() {
    $(`.product-compare-section.body .product-compare-list-box`).scrollLeft($(this).scrollLeft());
  });

  $(`.product-compare-section.body .product-compare-list-box`).on('scroll', function() {
    $(`.product-compare-section.sticky-bar .product-compare-list-box`).scrollLeft($(this).scrollLeft());
  });

  if (window.innerWidth <= 768) {
    if (current_url.includes('collections/portable-oxygen-concentrator') || 
       current_url.includes('collections/home-oxygen-concentrator')) {
      $(`.productitem__compare-wrapper`).addClass('mobile');
      $(`.productitem__compare-wrapper`).attr('data-animation-state', 'open');
    }
  }
  
})(jQuery);
